export class Pedido {
    comentario: string;
    plato: string;
    id: number;
    idUsuario: number;
    idPLato: number;

    constructor(comentario: string, plato: string, id: number, idUsuario: number, idPlato: number) {
        this.comentario = comentario;
        this.plato = plato;
        this.id = id;
        this.idUsuario = idUsuario;
        this.idPLato = idPlato;
    }

    setId(value: number) {
        this.id = value;
    }
    getId(): number {
        return this.id;
    }
    setIdUsuario(value: number) {
        this.idUsuario = value;
    }
    getIdUsuario(): number {
        return this.idUsuario;
    }
    setIdPlato(value: number) {
        this.idPLato = value;
    }
    getIdPlato(): number {
        return this.idPLato;
    }
    setComentario(value: string) {
        this.comentario = value;
    }
    getComentario(): string {
        return this.comentario;
    }
    setPlato(value: string) {
        this.plato = value;
    }
    getPlato(): string {
        return this.plato;
    }



}